/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DecisionPoll = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The DecisionPoll model module.
   * @module model/DecisionPoll
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DecisionPoll</code>.
   * @alias module:model/DecisionPoll
   * @class
   */
  var exports = function() {
    var _this = this;















  };

  /**
   * Constructs a <code>DecisionPoll</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DecisionPoll} obj Optional instance to populate.
   * @return {module:model/DecisionPoll} The populated <code>DecisionPoll</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Introduction')) {
        obj['Introduction'] = ApiClient.convertToType(data['Introduction'], 'String');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ReplyOptionTypeID')) {
        obj['ReplyOptionTypeID'] = ApiClient.convertToType(data['ReplyOptionTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('DeadLineTimeStamp')) {
        obj['DeadLineTimeStamp'] = ApiClient.convertToType(data['DeadLineTimeStamp'], 'Date');
      }
      if (data.hasOwnProperty('InitiativeID')) {
        obj['InitiativeID'] = ApiClient.convertToType(data['InitiativeID'], 'Integer');
      }
      if (data.hasOwnProperty('ActionID')) {
        obj['ActionID'] = ApiClient.convertToType(data['ActionID'], 'Integer');
      }
      if (data.hasOwnProperty('MilestoneID')) {
        obj['MilestoneID'] = ApiClient.convertToType(data['MilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('SWOTInboxID')) {
        obj['SWOTInboxID'] = ApiClient.convertToType(data['SWOTInboxID'], 'Integer');
      }
      if (data.hasOwnProperty('MeetingID')) {
        obj['MeetingID'] = ApiClient.convertToType(data['MeetingID'], 'Integer');
      }
      if (data.hasOwnProperty('InsightID')) {
        obj['InsightID'] = ApiClient.convertToType(data['InsightID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Introduction
   * @default ''
   */
  exports.prototype['Introduction'] = '';
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} ReplyOptionTypeID
   * @default 0
   */
  exports.prototype['ReplyOptionTypeID'] = 0;
  /**
   * @member {Date} DeadLineTimeStamp
   */
  exports.prototype['DeadLineTimeStamp'] = undefined;
  /**
   * @member {Integer} InitiativeID
   */
  exports.prototype['InitiativeID'] = undefined;
  /**
   * @member {Integer} ActionID
   */
  exports.prototype['ActionID'] = undefined;
  /**
   * @member {Integer} MilestoneID
   */
  exports.prototype['MilestoneID'] = undefined;
  /**
   * @member {Integer} SWOTInboxID
   */
  exports.prototype['SWOTInboxID'] = undefined;
  /**
   * @member {Integer} MeetingID
   */
  exports.prototype['MeetingID'] = undefined;
  /**
   * @member {Integer} InsightID
   */
  exports.prototype['InsightID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


